(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidFacilityLabDeleteController',CovidFacilityLabDeleteController);

    CovidFacilityLabDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidFacilityLab'];

    function CovidFacilityLabDeleteController($uibModalInstance, entity, CovidFacilityLab) {
        var vm = this;

        vm.covidFacilityLab = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidFacilityLab.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
